// Helpers for the "open the mobile app" banner shown on mobile browsers.

// Store fallbacks (mirror mobile/src/services/VersionCheckService.js STORE_URLS).
export const STORE_URLS = {
  ios: 'https://apps.apple.com/fr/app/neo-network/id6450933172',
  android: 'https://play.google.com/store/apps/details?id=com.neo_bec',
};

// Custom scheme for opening an installed Neo Network app from a page already
// hosted on neoevent.app. Universal/App Links do not open from the same domain.
export const MOBILE_APP_SCHEME = 'neonetwork://magic';

// Companion entry point. By default the mobile app preserves an authenticated
// account session; `?force=1` is supported by the app for an explicit future
// flow that intentionally replaces it with a companion session.
export const MOBILE_COMPANION_SCHEME = 'neonetwork://companion';

// Static Universal/App Link used when the user is NOT authenticated on the web.
// It opens the mobile app (logged out) if installed, otherwise the /magic
// landing page redirects to the store. Mirrors the backend MAGIC_LINK_BASE_URL
// domain/path (neoevent.app/magic). Authenticated magic links (with a one-time
// login token) are minted by the backend — see redux/magicLinkService.
// Defaults to the current web origin + /magic, so the banner points at the same
// environment it is served from (preprod web → neo-dev.on-forge.com/magic, prod
// → neoevent.app/magic) without a per-env build arg. Override with
// REACT_APP_MAGIC_LINK_URL only if the magic domain differs from the web origin.
export const MAGIC_LINK_BASE =
  process.env.REACT_APP_MAGIC_LINK_URL ||
  (typeof window !== 'undefined'
    ? `${window.location.origin}/magic`
    : 'https://neoevent.app/magic');

// Returns 'ios' | 'android' | null based on the browser user agent.
export const getMobilePlatform = () => {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || navigator.vendor || '';
  // iPadOS 13+ reports as Macintosh but is a touch device.
  // Use maxTouchPoints (not ontouchend on document) because Chrome on macOS
  // can expose touch APIs after DevTools mobile emulation or with some
  // accessibility setups — a false positive that blocks desktop magic-link login.
  const iPadOS =
    /Macintosh/.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0;
  if ((/iPad|iPhone|iPod/.test(ua) || iPadOS) && !window.MSStream) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return null;
};

export const isMobileBrowser = () => getMobilePlatform() !== null;

// True when already running as an installed PWA (no point promoting the app).
export const isStandaloneApp = () => {
  try {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    );
  } catch (e) {
    return false;
  }
};
